"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserService = void 0;
const environment_1 = require("../../constants/environment");
const environment_enum_1 = require("../enum/environment.enum");
const axios_1 = __importDefault(require("axios"));
const conektaAccounts = ['UNID', 'UERRE'];
class UserService {
    constructor(ENV = environment_enum_1.ENVIRONMENT.DEV, key, paymentGatewayEnv) {
        this.RESOURCE = 'user';
        //Este servicio de login no lo encuentro nisiquiera en el user service anterior
        this.login = async (user) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/login`;
            const response = await axios_1.default.post(URL, JSON.stringify(user), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        /**
         * Retrieves all Permissions
         * @param user {personId, companyId}
         * @returns List Permissions
         */
        //Este servicios no esta implementado en POINT esta comentado
        this.getPermissions = async (user) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/${user.person_id}/permissions/${user.company_id}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getPermissionsAxios = async (user) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/${user.person_id}/permissions/${user.company_id}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return Promise.resolve(response.data);
        };
        /**
         * get data user by identifier
         * @param {number} id user identifier
         * @returns  {object} user info
         */
        this.getById = async (id) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/table/entry/${id}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getByEmail = async (email, basic_data) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/email/${email}?basic_data=${basic_data || false}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getAll = async (page, filters = [], size = 10) => {
            let URL = `${environment_1.API_URL_BASE}/${this.ENV}/users?page=${page}&size=${size}`;
            for (let items of filters) {
                let filter = items;
                for (const key in filter) {
                    let keyFilter = key;
                    URL += `&${key}=${filter[keyFilter]}`;
                }
            }
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getData = async (person_id) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/${person_id}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        //Su implementacion en POINT esta comentada
        this.getPreMatriculacionData = async (body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/prematricula`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        //Su implementacion en POINT esta comentada
        this.updateOrderFolio = async (orderId, folio) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/prematricula/folio`;
            const response = await axios_1.default.post(URL, JSON.stringify({ orderId: orderId, folio: folio }), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.save = async (body) => {
            let URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/table/entry`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.update = async (body, id) => {
            let URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/table/entry/${id}`;
            const response = await axios_1.default.put(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.postContactProspect = async (body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/user/contact-prospect`;
            const response = await axios_1.default.post(URL, body, { headers: { 'x-api-key': this.KEY } });
            //const response = await instance.post('/user/test-vocational', body, {headers:{'x-api-key':this.KEY}})
            //return  (response.status===200)? Promise.resolve(response): Promise.reject(response);
            return (response.status === 200) ? Promise.resolve(response) : Promise.resolve(response);
        };
        this.postContactReferred = async (body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/user/contact-referred`;
            const response = await axios_1.default.post(URL, body, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response) : Promise.resolve(response);
        };
        this.getTotalContactsReferred = async (person_id) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/user/contact-referred/${person_id}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response) : Promise.resolve(response);
        };
        // Conekta
        /**
         * Agrega tarjetas de crédito, débito a un cliente proporcionado.
         * @param id. (Number) 'person_id'.
         * @param tokens. (Object) con la información del 'token_id' para asociar a tarjeta.
         * @return Object, con la información de la tarjeta que acaba de ser asociada.
         */
        this.conektaAddCustomerCard = async (id, tokens) => {
            const promises = [];
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/user/billing/${id}/payment-methods`;
            const conektaCustomer = await this.conektaGetCustomer(id);
            for (const customer of conektaCustomer) {
                const body = {
                    customer_id: customer.customer_id,
                    token_id: tokens[customer.ou]
                };
                let customerURL = `${URL}?ou=${customer.ou}`;
                if (this.PAYMENT_GATEWAY_ENV) {
                    customerURL += `&payment_gateway_env=${this.PAYMENT_GATEWAY_ENV}`;
                }
                promises.push(await axios_1.default.post(customerURL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } })
                    .then((response) => response === null || response === void 0 ? void 0 : response.data)
                    .catch((error) => error));
            }
            return Promise.resolve(Promise.all(promises).then(data => data).catch(error => error));
        };
        /**
         * Edita tarjetas de crédito, débito a un cliente proporcionado.
         * @param id. (Number) 'person_id'.
         * @param body. (Object) con la información de los 'payment_source_ids' y 'data'.
         * @return Object, con la información de la tarjeta que acaba de ser "editada".
         */
        this.conektaUpdateCustomerCard = async (id, body) => {
            const promises = [];
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/user/billing/${id}/payment-methods`;
            const conektaCustomer = await this.conektaGetCustomer(id);
            for (const customer of conektaCustomer) {
                body['customer_id'] = customer.customer_id;
                body['payment_source_id'] = body.payment_source_ids[customer.ou];
                let customerURL = `${URL}?ou=${customer.ou}`;
                if (this.PAYMENT_GATEWAY_ENV) {
                    customerURL += `&payment_gateway_env=${this.PAYMENT_GATEWAY_ENV}`;
                }
                promises.push(await axios_1.default.put(customerURL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } })
                    .then((response) => response === null || response === void 0 ? void 0 : response.data)
                    .catch((error) => error));
            }
            return Promise.resolve(Promise.all(promises).then(data => data).catch(error => error));
        };
        /**
         * Elimina las tarjetas de crédito, débito asociadas a un cliente.
         * @param id. (Number) 'person_id'.
         * @param payment_source_ids. (Object) Con los Id. de la tarjeta a eliminar.
         * @return Boolean, [true] si pudo eliminar la tarjeta o [false] en caso contrario.
         */
        this.conektaDeleteCustomerCard = async (id, payment_source_ids) => {
            const promises = [];
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/user/billing/${id}/payment-methods`;
            const conektaCustomer = await this.conektaGetCustomer(id);
            for (const customer of conektaCustomer) {
                const customer_id = customer.customer_id;
                const payment_source_id = payment_source_ids[customer.ou];
                let customerURL = `${URL}?ou=${customer.ou}&customer_id=${customer_id}&payment_source_id=${payment_source_id}`;
                if (this.PAYMENT_GATEWAY_ENV) {
                    customerURL += `&payment_gateway_env=${this.PAYMENT_GATEWAY_ENV}`;
                }
                promises.push(await axios_1.default.delete(customerURL, { headers: { 'x-api-key': this.KEY } })
                    .then((response) => response === null || response === void 0 ? void 0 : response.data)
                    .catch((error) => error));
            }
            return Promise.resolve(Promise.all(promises).then(data => data).catch(error => error));
        };
        /**
         * Obtiene las tarjetas de crédito, débito asociado a un cliente.
         * @param id. (Number) 'person_id'.
         * @return Array de objects, con las tarjetas asociadas y su información.
         */
        this.conektaGetCustomerCard = async (id) => {
            const promises = [];
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/user/billing/${id}/payment-methods`;
            const conektaCustomer = await this.conektaGetCustomer(id);
            for (const customer of conektaCustomer) {
                const customer_id = customer.customer_id;
                let customerURL = `${URL}?ou=${customer.ou}&customer_id=${customer_id}`;
                if (this.PAYMENT_GATEWAY_ENV) {
                    customerURL += `&payment_gateway_env=${this.PAYMENT_GATEWAY_ENV}`;
                }
                promises.push(await axios_1.default.get(customerURL, { headers: { 'x-api-key': this.KEY } })
                    .then((response) => ({ [customer.ou]: response === null || response === void 0 ? void 0 : response.data }))
                    .catch((error) => error));
            }
            return Promise.resolve(Promise.all(promises).then(cardsByOU => {
                let customerCards = [];
                let response = {};
                cardsByOU.map(cards => {
                    for (const account of conektaAccounts) {
                        if (cards[account]) {
                            cards[account].map((card) => {
                                card['ou'] = account;
                                customerCards.push(card);
                            });
                        }
                    }
                });
                const GroupBy = (items, key) => items.reduce((result, item) => (Object.assign(Object.assign({}, result), { [item[key]]: [...(result[item[key]] || []), item,] })), {});
                response = GroupBy(customerCards, 'last4');
                return Object.keys(response).map(key => response[key]);
            })
                .catch(error => error));
        };
        /**
         * Crear un cargo recurrente para un cliente.
         * @param id. (Number) 'person_id'.
         * @param body. (Object) con el 'plan_id'.
         * @return Object, con la información de la suscripción creada.
         * @deprecated The method should not be used.
         */
        this.conektaCreateCustomerSubscription = async (id, body) => {
            const promises = [];
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/user/billing/${id}/subscriptions`;
            const conektaCustomer = await this.conektaGetCustomer(id);
            for (const customer of conektaCustomer) {
                body['customer_id'] = customer.customer_id;
                promises.push(await axios_1.default.post(`${URL}?ou=${customer.ou}`, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } })
                    .then((response) => ({ [customer.ou]: response === null || response === void 0 ? void 0 : response.data }))
                    .catch((error) => error));
            }
            return Promise.resolve(Promise.all(promises).then(data => data).catch(error => error));
        };
        /**
         * Cancelación de un cargo recurrente para un cliente.
         * @param id. (Number) 'person_id'.
         * @return Boolean, [true] si pudo cancelar la suscripción o [false] en caso contrario.
         * @deprecated The method should not be used, Conekta subscriptions are not used.
         */
        this.conektaCancelCustomerSubscription = async (id) => {
            const promises = [];
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/user/billing/${id}/subscriptions`;
            const conektaCustomer = await this.conektaGetCustomer(id);
            for (const customer of conektaCustomer) {
                const customer_id = customer.customer_id;
                promises.push(await axios_1.default.delete(`${URL}?ou=${customer.ou}&customer_id=${customer_id}`, { headers: { 'x-api-key': this.KEY } })
                    .then((response) => ({ [customer.ou]: response === null || response === void 0 ? void 0 : response.data }))
                    .catch((error) => error));
            }
            return Promise.resolve(Promise.all(promises).then(data => data).catch(error => error));
        };
        /**
         * Obtiene la suscripción que tiene asociada un cliente.
         * @param id. (Number) 'person_id'.
         * @param customer_id. (String) El Id. del cliente Conekta.
         * @return Object, con la información de la suscripción.
         * @deprecated The method should not be used, Conekta subscriptions are not used.
         */
        this.conektaGetCustomerSubscription = async (id) => {
            const promises = [];
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/user/billing/${id}/subscriptions`;
            const conektaCustomer = await this.conektaGetCustomer(id);
            for (const customer of conektaCustomer) {
                const customer_id = customer.customer_id;
                if (customer_id) {
                    promises.push(await axios_1.default.get(`${URL}?ou=${customer.ou}&customer_id=${customer_id}`, { headers: { 'x-api-key': this.KEY } })
                        .then((response) => response === null || response === void 0 ? void 0 : response.data)
                        .catch((error) => error));
                }
            }
            return Promise.resolve(Promise.all(promises).then(data => data).catch(error => error));
        };
        /**
         * Obtiene los datos del usuario en Conekta mediante su person_id.
         * @param id. (Number) 'person_id'
         * @return Array de objects, con la información del usuario en Conekta.
         */
        this.conektaGetCustomer = async (id) => {
            const promises = [];
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/user/billing/${id}`;
            for (const account of conektaAccounts) {
                let customerURL = `${URL}?ou=${account}`;
                if (this.PAYMENT_GATEWAY_ENV) {
                    customerURL += `&payment_gateway_env=${this.PAYMENT_GATEWAY_ENV}`;
                }
                promises.push(await axios_1.default.get(customerURL, { headers: { 'x-api-key': this.KEY } })
                    .then((response) => { var _a; return (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data; })
                    .catch((error) => error));
            }
            return Promise.resolve(Promise.all(promises).then(data => data).catch(error => error));
        };
        this.getRolesByUser = async (person_id) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/user/table/entry/person-role/${person_id}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        /**
         * Obtiene todas las clases que imparte el usuario (en este caso es un instructor), tanto
         * en UNID como UERRE (si es que da impartición de materias en ambas UO).
         * @param userid. Int. El person_id del instructor.
         * @param viewAll. Boolean. Parametro para indicar si se requiere ver todo el registro existente de materias impartidas.
         * @returns Array de Objetos anidados con la información en formato:
         * "periodos" => "clases" => [... grupos a los que se imparte la materia].
         */
        this.getInstructorClasses = async (userid, viewAll) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/user/instructor/${userid}/classes?view_all=${viewAll}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.findNeoUserByEmail = async (user_id, company_id) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/neo/find/email?user_id=${user_id}&company_id=${company_id}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.userNeoArchived = async (body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/neo/archived-user`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getProfilePicAsBase64ByPersonId = async (person_id) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/profile/picture?person_id=${person_id}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.userTermsAcept = async (body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/user/terms`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getUserTerms = async (person_id) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/user/terms/${person_id}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.getUserTagPersonId = async (person_id) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/tags?person_id=${person_id}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        /**
         * Obtiene las suscripciones actuales de una persona
         * @param id. (Number) 'person_id'.
         */
        this.getPersonSubscriptions = async (id) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/user/billing/${id}/subscriptions/debits`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        /**
         * Cancela un pago recurrente de la suscripción especificada.
         * @param id. (Number) 'person_id'.
         * @param subscription_id. (String) 'subscription_id'.
         */
        this.deletePersonSubscription = async (id, subscription_id) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/user/billing/${id}/subscriptions/debits?subscription_id=${subscription_id}`;
            const response = await axios_1.default.delete(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        /**
         * Valida al usuario antes de pasar a la pasarela de pago que cumpla con los datos minimos para el pago.
         * @param personId
         * @returns (Object) status = true (Indica usuario valido), status = false (Indica que algún dato {person_info} esta incorrecto),
         */
        this.validateBeforePaymentGateway = async (personId) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE + 's'}/${personId}/validate_before_payment_gateway`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            if (response.status === 200) {
                return Promise.resolve(response.data);
            }
            return Promise.reject(response.statusText);
        };
        /**
         * Obtiene los productos pendientes por asignar después de adquirirlos con una compra.
         * @param personId
         * @returns (Object) product
         */
        this.getPendingProductAssignments = async (personId) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/${personId}/products/pending-assignments`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            if (response.status === 200) {
                return Promise.resolve(response.data);
            }
            return Promise.reject(response.statusText);
        };
        /**
         * Obtiene los productos asignados de una persona.
         * @param personId ID de la persona
         * @param filters Filtro de producto por category_id, product_type_id o sku.
         * @returns (Array) productos
         */
        this.getPersonProducts = async (personId, filters) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/${personId}/products/assigned`;
            const objectToQueryString = (obj) => Object.keys(obj).map(key => `${key}=${obj[key]}`).join("&");
            const _URL = filters ? `${URL}?${objectToQueryString(filters)}` : URL;
            const response = await axios_1.default.get(_URL, { headers: { 'x-api-key': this.KEY } });
            if (response.status === 200) {
                return Promise.resolve(response.data);
            }
            return Promise.reject(response.statusText);
        };
        this.updateCurp = async (personId, body) => {
            let URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/${personId}/curp`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        /**
         * Obtiene el correo principal basado en uno de los tres posibles parámetros: person_id, user_id, o pidm.
         * @param {string} paramType - Tipo de parámetro (puede ser 'personId', 'userId', o 'pidm').
         * @param {number|string} paramValue - Valor del parámetro.
         * @returns {Promise<Object>} - El correo principal.
         */
        this.getMainEmail = async (paramType, paramValue) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/${this.RESOURCE}/email/main?${paramType}=${paramValue}`;
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            if (response.status === 200) {
                return Promise.resolve(response.data);
            }
            return Promise.reject(response.statusText);
        };
        this.ENV = ENV;
        this.KEY = key;
        this.PAYMENT_GATEWAY_ENV = paymentGatewayEnv;
    }
}
exports.UserService = UserService;
